import { useState } from 'react';
import { PiArrowCounterClockwise, PiCalendarCheck } from 'react-icons/pi';

import { DEFAULT_DEMO_VARIANT_SLUG } from '@aldebaran/common/qVariants';

import { getDemoLaunchErrorMessage } from '@/components/DemoLead/demoLaunchError';
import { loadDemoLead } from '@/components/DemoLead/demoLeadStorage';
import { useLaunchDemo } from '@/components/DemoLead/useLaunchDemo';
import { Button } from '@/components/ui/button';
import config from '@/config';

export const DemoNextSteps = () => {
  const launchDemo = useLaunchDemo();
  const [isRestarting, setIsRestarting] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [storedLead] = useState(loadDemoLead);
  const variantSlug = storedLead?.variantSlug ?? DEFAULT_DEMO_VARIANT_SLUG;

  const handleRestart = async () => {
    if (isRestarting) return;
    setIsRestarting(true);
    setError(null);
    if (!storedLead) {
      // Lead lost (storage unavailable) — reload the entry URL without the
      // demo_lead marker so the lead-capture modal collects it again
      window.location.href = `/${config.demoPracticeSlug}?variant=${variantSlug}`;
      return;
    }
    try {
      // Reuses the lead created on the first launch
      await launchDemo(
        {
          firstName: storedLead.firstName,
          lastName: storedLead.lastName,
          email: storedLead.email,
          speciality: storedLead.speciality,
          variantSlug,
        },
        storedLead.demoRequestId,
      );
    } catch (restartError) {
      // Launching navigates away, so this only runs when it failed before
      // the redirect — release the button rather than leaving it disabled
      setError(getDemoLaunchErrorMessage(restartError));
      setIsRestarting(false);
    }
  };

  return (
    <div className="flex flex-col items-center gap-3 mt-4 z-50 px-4 n2xs:px-6 nsm:px-0">
      <Button
        variant="offboarding"
        size="offboarding"
        onClick={() => window.open(config.demoLemcalUrl, '_blank')}
      >
        <PiCalendarCheck className="size-6" />
        Prendre RDV avec l&apos;équipe
      </Button>

      <Button
        variant="offboarding"
        size="offboarding"
        disabled={isRestarting}
        onClick={handleRestart}
      >
        <PiArrowCounterClockwise className="size-6" />
        {isRestarting ? 'Lancement en cours…' : 'Recommencer un questionnaire'}
      </Button>

      {error && (
        <p role="alert" className="text-center text-sm text-red-600">
          {error}
        </p>
      )}
    </div>
  );
};
